import { styled } from "@mui/material";
import { IStyledMainContentProps } from "./types";
import { drawerWidth as defaultDrawerWidth } from "../../../consts/drawerWidth";
import { SIDEBAR_WIDTH_COLLAPSED, SIDEBAR_WIDTH_EXPANDED } from "../../../consts/sidebarWidth";
import { APP_BAR_HEIGHT } from "../../../consts/appBarHeight";

const StyledMainContent = styled('main', {
  shouldForwardProp: (prop) =>
    prop !== 'open' && prop !== 'sidebarOpen' && prop !== 'chatWidth' && prop !== 'isResizing',
})<IStyledMainContentProps>(({ theme, open, sidebarOpen, chatWidth, isResizing }) => ({
  // ensure main sits below the AppBar and never exceeds the viewport
  flexGrow: 1,
  marginTop: `${APP_BAR_HEIGHT}px`,
  height: `calc(100vh - ${APP_BAR_HEIGHT}px)`,
  overflow: 'auto',
  padding: theme.spacing(2),
  // Skipped while the chat is being dragged — a CSS transition fighting with real-time pointer
  // updates makes the resize feel laggy instead of following the cursor 1:1.
  transition: isResizing ? 'none' : theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  maxWidth: '100%',
  marginLeft: sidebarOpen ? SIDEBAR_WIDTH_EXPANDED : SIDEBAR_WIDTH_COLLAPSED,
  marginRight: open ? (chatWidth ?? defaultDrawerWidth) : 0,
  position: 'relative',
  boxSizing: 'border-box',
  // no mobile a sidebar vira overlay e o chat cobre a tela: o conteúdo usa toda a largura
  [theme.breakpoints.down('md')]: {
    marginLeft: 0,
    marginRight: 0,
    padding: theme.spacing(1.5),
  },
}));

export { StyledMainContent }
